<!-- TODO componente non usato -->
<div class="container-related-events">
    <div class="container">
        <app-header-event></app-header-event>
        <div class="container-related-events__box-item d-flex flex-row">
            <div class="container-related-events__box-item__item col-6">
                <app-sample-card-related></app-sample-card-related>
            </div>
        </div>
    </div>
</div>